// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {CheckboxEl} from 'common/components/checkbox';
import {InputGroupEl} from 'common/components/input-group';
import {SpinnerEl} from 'common/components/spinner';
import {SvgIconEl} from 'common/components/svg-icon';

import type {PublicDashboardPasswordRow} from './index';

export function template(this: PublicDashboardPasswordRow) {
  const checkboxDisabled = this.state.removePasswordLoading || this.state.setPasswordLoading;
  return (
    <div sel='.public-dashboard-password-row'>
      <CheckboxEl
        attrs={{
          checked: this.attr(`password-protected`) || this.state.editingPassword,
          elref: `passwordRowCheckbox_${this.attr(`public-link-id`)}`,
          disabled: checkboxDisabled,
        }}
        on={{click: !checkboxDisabled && this.helpers.handleCheckboxClick}}
      >
        Require Passcode
        {this.state.removePasswordLoading && <SpinnerEl />}
      </CheckboxEl>
      <div
        sel='.input-area'
        class={{
          'editing-password': this.state.editingPassword,
        }}
      >
        {this.state.editingPassword ? (
          <div sel='.edit-password-wrapper'>
            <InputGroupEl
              attrs={{
                elref: `passwordRowInputGroup_${this.attr(`public-link-id`)}`,
                label: `Save`,
                value: this.state.password,
                busy: this.state.setPasswordLoading,
                disabled: this.state.setPasswordLoading,
                required: true,
                min: 8,
                maxlength: 32,
                'value-type': `passcode`,
                'value-type-article': `a`,
              }}
              on={{
                input: this.helpers.handlePasswordInput,
                submit: this.helpers.handleSaveClick,
              }}
              sel='.password-input'
            />
            <div sel='.password-info-wrapper'>
              <span sel='.info-icon'>
                <SvgIconEl attrs={{icon: `info`}} />
              </span>
              <div sel='.info-text-wrapper'>
                <p> Minimum length of 8 characters.</p>
                <p> Passcodes can not be recovered after they are set.</p>
              </div>
            </div>
          </div>
        ) : (
          this.attr(`password-protected`) && (
            <span sel='.password-protected-wrapper'>
              •••••••
              <ButtonEl
                sel='.edit-btn'
                on={{click: this.helpers.handleEditClick}}
                attrs={{elref: `linkPasswordResetButton`}}
              >
                Reset
              </ButtonEl>
              {this.attr(`public-link-embed-link-with-passcode`).length ? (
                <ButtonEl
                  sel='.edit-btn'
                  on={{click: () => this.helpers.copyEmbedLink(this.attr(`public-link-embed-link-with-passcode`))}}
                  attrs={{icon: `duplicate`, elref: `embedLinkButton`}}
                >
                  Embed Link
                </ButtonEl>
              ) : null}
            </span>
          )
        )}
      </div>
    </div>
  );
}
